<template>
  <div class="placement-activity-table-wrapper">
    <br />
    <tol-table
      :table-data="placementActivityTableList"
      :columns="placementActivityColumns"
      :is-row-clickable="true"
      @row-click="handleRowClick($event)"
    >
      <template v-slot:tableHeader>
        <template v-for="c in placementActivityColumns">
          <th :key="c">
            {{ c }}
          </th></template
        >
      </template>
    </tol-table>
    <Pagination
      :records-per-page="activityResultsPerPage"
      :offset="currentPage"
      :record-count="recordCount"
      @change="onChangePaginationParams($event)"
    />
  </div>
</template>
<script>
import TolTable from '@/app/components/TolTable';
import Pagination from '@/app/components/Pagination';
import { PlacementActivityGetters, PlacementActivityActions } from '../placement-activity.keys';
export default {
  name: 'PlacementActivityTable',
  components: {
    TolTable,
    Pagination
  },
  data() {
    return {
      placementActivityList: []
    };
  },
  computed: {
    placementActivityTableList() {
      return this.$store.getters[PlacementActivityGetters.PlacementActivityList]
        ? this.$store.getters[PlacementActivityGetters.PlacementActivityList]
        : [];
    },
    placementActivityColumns() {
      return [
        'Category',
        'Branch',
        'Division',
        'Payroll # / Invoice #',
        'Contractor Name',
        'Client Name',
        'Start Date',
        'Stop Date',
        'Pay Rate / Salary',
        'Bill Rate / Fee',
        'Recruiters'
      ];
    },
    activityResultsPerPage() {
      return this.$store.getters[PlacementActivityGetters.ActivityResultsPerPage];
    },
    currentPage() {
      return this.$store.getters[PlacementActivityGetters.ActivityResultsOffset];
    },
    recordCount() {
      return this.$store.getters[PlacementActivityGetters.ActivityResultsRecordCount];
    }
  },
  methods: {
    onChangePaginationParams(event) {
      this.$store.dispatch(PlacementActivityActions.SetActivityPaginationParameters, event);
    }
  }
};
</script>
<style>
.placement-activity-table-wrapper {
  min-height: 8rem;
}
.placement-activity-table-header {
  display: flex;
  flex-direction: row;
  font-size: 1.3rem;
  justify-content: space-around;
  align-items: center;
  height: 3rem;
  text-align: center;
  background-color: lightgrey;
}
</style>
